import React, { useState, useRef, useEffect } from 'react';
import './AddProfilePhoto.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Navbar, Form, Modal, Spinner } from 'react-bootstrap';
import { FaCheckCircle, FaTrashAlt, FaEdit, FaCamera, FaUpload } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import img from '../../Pages/Images/empphoto1.webp';
// Import your cartoon images
import cartoon1 from '../../Pages/Images/cartoon1.webp';
import cartoon5 from "../../Pages/Images/cartoon5.webp"
import cartoon6 from '../../Pages/Images/cartoon6.webp';
import cartoon7 from '../../Pages/Images/cartoon7.webp';
import cartoon8 from '../../Pages/Images/cartoon8.webp';
import cartoon9 from '../../Pages/Images/cartoon9.webp';
import cartoon10 from '../../Pages/Images/cartoon10.webp';
import cartoon11 from '../../Pages/Images/cartoon11.webp';
import cartoon12 from '../../Pages/Images/cartoon12.webp';
import cartoon17 from '../../Pages/Images/cartoon17.webp';
import cartoon18 from '../../Pages/Images/cartoon18.webp';
import cartoon19 from '../../Pages/Images/cartoon19.webp';
import cartoon20 from '../../Pages/Images/cartoon20.webp';
import cartoon21 from '../../Pages/Images/cartoon21.webp';
import cartoon22 from '../../Pages/Images/cartoon22.webp';
import cartoon23 from '../../Pages/Images/cartoon23.webp';
import cartoon25 from '../../Pages/Images/cartoon25.webp';
import cartoon26 from '../../Pages/Images/cartoon26.webp';
import cartoon27 from '../../Pages/Images/cartoon27.webp';
import cartoon28 from '../../Pages/Images/cartoon28.webp';
import EmployerNavbar from '../../Pages/Navbar/EmployerNavbar';
import axios from 'axios';
import BaseUrl from '../../ApiServices/BaseUrl';

const AddProfilePhoto = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userId, temporaryId } = location.state || {};
  const fileInputRef = useRef(null);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [savedProfilePhoto, setSavedProfilePhoto] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [selectedCartoon, setSelectedCartoon] = useState(null);
  const [userSubscriptionPlan, setUserSubscriptionPlan] = useState(null);

  // Cartoon images array
  const cartoonImages = [
    { id: 'cartoon1', image: cartoon1, label: 'Cartoon 1' },
    { id: 'cartoon5', image: cartoon5, label: 'Cartoon 2' },
    { id: 'cartoon6', image: cartoon6, label: 'Cartoon 3' },
    { id: 'cartoon7', image: cartoon7, label: 'Cartoon 4' },
    { id: 'cartoon8', image: cartoon8, label: 'Cartoon 5' },
    { id: 'cartoon9', image: cartoon9, label: 'Cartoon 6' },
    { id: 'cartoon10', image: cartoon10, label: 'Cartoon 7' },
    { id: 'cartoon11', image: cartoon11, label: 'Cartoon 8' },
    { id: 'cartoon12', image: cartoon12, label: 'Cartoon 9' },
    { id: 'cartoon17', image: cartoon17, label: 'Cartoon 10' },
    { id: 'cartoon18', image: cartoon18, label: 'Cartoon 11' },
    { id: 'cartoon19', image: cartoon19, label: 'Cartoon 12' },
    { id: 'cartoon20', image: cartoon20, label: 'Cartoon 13' },
    { id: 'cartoon21', image: cartoon21, label: 'Cartoon 14' },
    { id: 'cartoon22', image: cartoon22, label: 'Cartoon 15' },
    { id: 'cartoon23', image: cartoon23, label: 'Cartoon 16' },
     { id: 'cartoon25', image: cartoon25, label: 'Cartoon 17' },
    { id: 'cartoon26', image: cartoon26, label: 'Cartoon 18' },
    { id: 'cartoon27', image: cartoon27, label: 'Cartoon 19' },
    { id: 'cartoon28', image: cartoon28, label: 'Cartoon 20' },
  
  ];

  // Fetch user subscription plan on component mount
  useEffect(() => {
    const fetchUserSubscriptionPlan = async () => {
      if (!userId) return;

      try {
        const response = await axios.get(`${BaseUrl}/api/employer/subscription/${userId}`);
        const planName = response.data?.subscription?.plan_name || null;
        setUserSubscriptionPlan(planName);
      } catch (error) {
        console.error('Error fetching user subscription plan:', error);
        // If there's an error, assume no subscription
        setUserSubscriptionPlan(null);
      }
    };

    fetchUserSubscriptionPlan();
  }, [userId]);

  // Fetch existing profile photo on component mount
  useEffect(() => {
    const fetchProfilePhoto = async () => {
      if (!userId || !temporaryId) return;

      try {
        const response = await axios.get(
          `${BaseUrl}/api/employer?temporary_id=${temporaryId}&user_id=${userId}`
        );

        if (response.data && response.data.profile_photo) {
          setSavedProfilePhoto(response.data.profile_photo);
          setPreviewImage(`${BaseUrl}${response.data.profile_photo}`);
          setSelected(1);

          // Check if the saved photo is one of the cartoons
          const isCartoon = cartoonImages.some(cartoon =>
            response.data.profile_photo.includes(cartoon.id)
          );
          if (isCartoon) {
            setSelectedCartoon(response.data.profile_photo);
          }
        }
      } catch (error) {
        console.error('Error fetching profile photo:', error);
      }
    };

    fetchProfilePhoto();
  }, [userId, temporaryId]);

  const photos = [
    {
      id: 1,
      label: 'Profile Photo',
      image: previewImage || img,
    },
  ];

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match('image.*')) {
        toast.error('Please select an image file');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        toast.error('File size should be less than 5MB');
        return;
      }
      setSelectedFile(file);
      setSelectedCartoon(null); // Reset cartoon selection
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setSelected(1);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleCameraClick = () => {
    setShowCameraModal(true);
  };

  const handleCapture = () => {
    const mockCameraImage = img;
    setCapturedImage(mockCameraImage);
    setPreviewImage(mockCameraImage);
    setSelected(1);
    setSelectedCartoon(null); // Reset cartoon selection
    setShowCameraModal(false);
    setSelectedFile(null);
  };

  const handleCartoonSelect = (cartoon) => {
    setSelectedCartoon(cartoon.id);
    setPreviewImage(cartoon.image);
    setSelected(1);
    setSelectedFile(null); // Reset file selection
    setCapturedImage(null); // Reset camera capture
  };

  const handleRemovePhoto = () => {
    setPreviewImage(null);
    setSelected(null);
    setCapturedImage(null);
    setSelectedFile(null);
    setSavedProfilePhoto(null);
    setSelectedCartoon(null);
  };

  // Convert image URL to blob
  const urlToBlob = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return blob;
    } catch (error) {
      console.error('Error converting URL to blob:', error);
      throw error;
    }
  };

  // Function to check if user has active Silver or Gold subscription
  const hasActiveSubscription = () => {
    if (!userSubscriptionPlan) return false;

    const plan = userSubscriptionPlan.toLowerCase();
    return plan.includes('silver') || plan.includes('gold');
  };

  // Function to determine navigation path based on subscription
  const getNavigationPath = () => {
    if (hasActiveSubscription()) {
      return '/viewjobposting';
    }
    return '/subscriptionplans';
  };

  const handleSubmit = async () => {
    if (!selected) {
      toast.error('Please select or upload a photo');
      return;
    }

    if (!userId || !temporaryId) {
      toast.error('User information missing');
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('temporary_id', temporaryId);
      formData.append('user_id', userId);

      // Handle different image sources
      if (selectedFile) {
        // Uploaded file
        formData.append('profile_photo', selectedFile);
      } else if (selectedCartoon) {
        // Cartoon image - convert to file and upload
        const cartoon = cartoonImages.find(c => c.id === selectedCartoon);
        if (cartoon) {
          const blob = await urlToBlob(cartoon.image);
          const file = new File([blob], `${cartoon.id}.jpg`, { type: 'image/jpeg' });
          formData.append('profile_photo', file);
        }
      } else if (previewImage && previewImage !== img) {
        // Camera capture or existing photo
        if (previewImage.startsWith('data:')) {
          // Convert data URL to blob
          const blob = await fetch(previewImage).then(r => r.blob());
          const file = new File([blob], 'profile-photo.png', { type: 'image/png' });
          formData.append('profile_photo', file);
        } else {
          // Existing photo URL - convert to blob
          const blob = await urlToBlob(previewImage);
          const file = new File([blob], 'existing-photo.jpg', { type: 'image/jpeg' });
          formData.append('profile_photo', file);
        }
      }

      const response = await axios.post(
        `${BaseUrl}/api/employer`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.message) {
        // Show success popup
        await Swal.fire({
          title: 'Success!',
          text: 'Profile photo saved successfully',
          icon: 'success',
          confirmButtonText: 'OK'
        });

        setIsSaved(true); // ✅ Enable "Next" button

        // Fetch the updated profile photo
        const getResponse = await axios.get(
          `${BaseUrl}/api/employer?temporary_id=${temporaryId}&user_id=${userId}`
        );

        if (getResponse.data && getResponse.data.profile_photo) {
          setSavedProfilePhoto(getResponse.data.profile_photo);
          setPreviewImage(`${BaseUrl}${getResponse.data.profile_photo}`);

          // Check if it's a cartoon
          const isCartoon = cartoonImages.some(cartoon =>
            getResponse.data.profile_photo.includes(cartoon.id)
          );
          if (isCartoon) {
            const cartoon = cartoonImages.find(c => getResponse.data.profile_photo.includes(c.id));
            setSelectedCartoon(cartoon ? cartoon.id : null);
          } else {
            setSelectedCartoon(null);
          }
        }
      }

      // Determine navigation path based on subscription
      let navigationPath = getNavigationPath();
      if (location.state?.fromRegistration) {
        navigationPath = `/viewjobdetails/${temporaryId}`;
      }

      // Navigate to appropriate path with state
      navigate(navigationPath, {
        state: {
          jobId: temporaryId,
          userId,
          temporaryId,
          fromPhotoUpload: true,
          showJobPopupAfter: location.state?.showJobPopupAfter
        }
      });

    } catch (error) {
      console.error('Error uploading photo:', error);
      toast.error(error.response?.data?.message || 'Failed to upload photo');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <EmployerNavbar />
      <Container className="photo-selector-container">
        <div className="card shadow-sm p-4"> {/* Add this card wrapper */}
          <h5 className="text-center mb-4">Select any option</h5>

          {/* Cartoon Images Section - MOVED TO TOP */}
          <div className="cartoon-section mt-3">
            <h6 className="text-center mb-3">Choose a cartoon avatar</h6>
            <Row className="justify-content-center">
              {cartoonImages.map((cartoon) => (
                <Col xs={4} sm={2} className="mb-3" key={cartoon.id}>
                  <div
                    className={`cartoon-card ${selectedCartoon === cartoon.id ? 'selected' : ''}`}
                    onClick={() => handleCartoonSelect(cartoon)}
                  >
                    {selectedCartoon === cartoon.id && <FaCheckCircle className="check-icon" />}
                    <img
                      src={cartoon.image}
                      alt={cartoon.label}
                      className="cartoon-img"
                    />
                    <div className="cartoon-label text-center mt-2">
                      {cartoon.label}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '10px' }}>
            <span className="mx-2 fw-bold">(OR)</span>
          </div>

          {/* Profile Photo Section - MOVED BELOW */}
          <Row className="photo-options justify-content-center">
            {photos.map((photo) => (
              <Col xs={12} sm={4} className="mb-4" key={photo.id}>
                <div
                  className={`photo-card ${selected === photo.id ? 'selected' : ''}`}
                  onClick={() => setSelected(photo.id)}
                >
                  {selected === photo.id && <FaCheckCircle className="check-icon" />}
                  <img
                    src={photo.image}
                    alt={photo.label}
                    className="photo-img"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = img;
                    }}
                  />
                  <div className="photo-actions">
                    <span
                      className="action-text text-danger fw-bold"
                      style={{ cursor: "pointer", marginRight: "10px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemovePhoto();
                      }}
                    >
                      Delete
                    </span>
                    <span
                      className="action-text text-primary fw-bold"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUploadClick();
                      }}
                    >
                      Update
                    </span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Rest of your existing code remains the same */}
          <div className="text-center mb-3">
            <Button className="btn-option me-2" onClick={handleUploadClick}>
              <FaUpload className="me-2" /> Upload Photo
            </Button>
          </div>

          <Form>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/*"
              style={{ display: 'none' }}
            />
          </Form>

          <p className="note text-center">
            <span className="text-danger fw-bold">Note</span> - Select an avatar or upload your photo.
          </p>

          <div className="additional-section mb-4" style={{ marginTop: '20px' }}>
            <Button
              className="nav-btn w-100" style={{ flex: 1 }}
              variant="primary"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  <span className="ms-2">Processing...</span>
                </>
              ) : (
                <>
                  <FaCheckCircle className="me-2" /> Submit
                </>
              )}
            </Button>
          </div>
        </div> {/* Close the card wrapper */}
      </Container>

      {/* Camera Modal */}
      <Modal show={showCameraModal} onHide={() => setShowCameraModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Take a Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="camera-preview mb-3">
            {capturedImage ? (
              <img src={capturedImage} alt="Captured" className="img-fluid" />
            ) : (
              <div className="camera-placeholder">
                <FaCamera size={50} />
                <p>Camera Preview</p>
              </div>
            )}
          </div>
          <Button variant="primary" onClick={handleCapture} className="me-2">
            <FaCamera className="me-2" /> Capture
          </Button>
          <Button variant="secondary" onClick={() => setShowCameraModal(false)}>
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddProfilePhoto;
